import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import IconDelete from "../../Icons/IconDelete";
import IconEdit from "../../Icons/IconEdit";

import {
  Container,
  ContainerIcons,
  ContainerDelete,
  ContainerEdit,
  ImageBack,
  ContainerImage,
  Image,
  Left,
  Title,
  Description,
  Button,
} from "./styles";

const CardRedirectionLink = ({ item, setDelTheme, setEditTheme, admin }) => {
  // eslint-disable-next-line
  const BLOB_STORAGE_URL = process.env.REACT_APP_BLOB_STORAGE_URL;
  const [image, setImage] = useState(null);

  const handleRedirect = () => {
    window.open(item.url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (item.image) {
      setImage(`${BLOB_STORAGE_URL}${item.image}`);
    }
  }, [BLOB_STORAGE_URL, item.image]);

  return (
    <Container admin={admin}>
      {setDelTheme && setEditTheme && (
        <ContainerIcons>
          <ContainerDelete onClick={() => setDelTheme(item.id)}>
            <IconDelete />
          </ContainerDelete>
          <ContainerEdit onClick={() => setEditTheme(item)}>
            <IconEdit />
          </ContainerEdit>
        </ContainerIcons>
      )}
      <ImageBack src={"/ThemesBack.png"} />
      <Left onClick={handleRedirect}>
        <Title>{item.title}</Title>
        <Description>{item.description}</Description>
        <Button>
          {item.url.slice(0, 20)}
          {item.url.length > 19 ? "..." : ""}
        </Button>
      </Left>
      <ContainerImage>
        <Image src={image || "/defaultImage.png"} />
      </ContainerImage>
    </Container>
  );
};

CardRedirectionLink.propTypes = {
  item: PropTypes.object,
  setDelTheme: PropTypes.func,
  setEditTheme: PropTypes.func,
  admin: PropTypes.bool,
};

export default CardRedirectionLink;
